export const BATCH_PROBLEM_SPECS = [
  {
    "source": "docx-batch",
    "sourceId": "DSA0001",
    "title": "Array Pair Target 1",
    "slug": "array-pair-target-1",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 1,
    "difficulty": "Easy",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0002",
    "title": "Array Pair Target 2",
    "slug": "array-pair-target-2",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 2,
    "difficulty": "Easy",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0003",
    "title": "Array Pair Target 3",
    "slug": "array-pair-target-3",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 3,
    "difficulty": "Easy",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0004",
    "title": "Array Pair Target 4",
    "slug": "array-pair-target-4",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 4,
    "difficulty": "Easy",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0005",
    "title": "Array Pair Target 5",
    "slug": "array-pair-target-5",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 5,
    "difficulty": "Easy",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0006",
    "title": "Array Pair Target 6",
    "slug": "array-pair-target-6",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 6,
    "difficulty": "Easy",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0007",
    "title": "Array Pair Target 7",
    "slug": "array-pair-target-7",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 7,
    "difficulty": "Easy",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0008",
    "title": "Array Pair Target 8",
    "slug": "array-pair-target-8",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 8,
    "difficulty": "Medium",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0009",
    "title": "Array Pair Target 9",
    "slug": "array-pair-target-9",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 9,
    "difficulty": "Medium",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0010",
    "title": "Array Pair Target 10",
    "slug": "array-pair-target-10",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 10,
    "difficulty": "Medium",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0011",
    "title": "Array Pair Target 11",
    "slug": "array-pair-target-11",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 11,
    "difficulty": "Medium",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0012",
    "title": "Array Pair Target 12",
    "slug": "array-pair-target-12",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 12,
    "difficulty": "Medium",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0013",
    "title": "Array Pair Target 13",
    "slug": "array-pair-target-13",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 13,
    "difficulty": "Medium",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0014",
    "title": "Array Pair Target 14",
    "slug": "array-pair-target-14",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 14,
    "difficulty": "Medium",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0015",
    "title": "Array Pair Target 15",
    "slug": "array-pair-target-15",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 15,
    "difficulty": "Medium",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0016",
    "title": "Array Pair Target 16",
    "slug": "array-pair-target-16",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 16,
    "difficulty": "Medium",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0017",
    "title": "Array Pair Target 17",
    "slug": "array-pair-target-17",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 17,
    "difficulty": "Medium",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0018",
    "title": "Array Pair Target 18",
    "slug": "array-pair-target-18",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 18,
    "difficulty": "Medium",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0019",
    "title": "Array Pair Target 19",
    "slug": "array-pair-target-19",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 19,
    "difficulty": "Medium",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0020",
    "title": "Array Pair Target 20",
    "slug": "array-pair-target-20",
    "batchNumber": 1,
    "batchLabel": "Batch 1 - 20 Original Interview Style Problems",
    "globalOrdinal": 20,
    "difficulty": "Medium",
    "patterns": [
      "Arrays",
      "Hash Map"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Microsoft",
      "Google (similar concepts)"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "You are given a list of integers representing item scores and a target score. Return the indices of any two distinct elements whose sum equals the target. If no such pair exists, return -1 -1. Indices are zero-based.",
    "inputFormat": "First line: integer n. Second line: n space-separated integers. Third line: target integer.",
    "outputFormat": "Two space-separated indices in increasing order, or -1 -1 if no valid pair exists.",
    "constraints": "2 <= n <= 100000 -10^9 <= value <= 10^9",
    "sampleInput": "5 4 7 1 9 5 10",
    "sampleOutput": "2 3",
    "explanation": "Values at indices 2 and 3 are 1 and 9, whose sum is 10.",
    "expectedApproach": "Traverse once while storing visited values in a hash map. For each value, check whether target-current exists.",
    "timeComplexity": "O(n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_1_20_Original_Interview_Problems.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_1_20_Original_Interview_Problems.txt",
    "qualityFlags": []
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0021",
    "title": "Strings Challenge 21",
    "slug": "strings-challenge-21",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 21,
    "difficulty": "Medium",
    "patterns": [
      "Strings"
    ],
    "primaryTopic": "Strings",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original strings interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0022",
    "title": "Sliding Window Challenge 22",
    "slug": "sliding-window-challenge-22",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 22,
    "difficulty": "Medium",
    "patterns": [
      "Sliding Window"
    ],
    "primaryTopic": "Sliding Window",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original sliding window interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0023",
    "title": "Stack Challenge 23",
    "slug": "stack-challenge-23",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 23,
    "difficulty": "Medium",
    "patterns": [
      "Stack"
    ],
    "primaryTopic": "Stack",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original stack interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0024",
    "title": "Queue Challenge 24",
    "slug": "queue-challenge-24",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 24,
    "difficulty": "Medium",
    "patterns": [
      "Queue"
    ],
    "primaryTopic": "Queue",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original queue interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0025",
    "title": "Binary Search Challenge 25",
    "slug": "binary-search-challenge-25",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 25,
    "difficulty": "Medium",
    "patterns": [
      "Binary Search"
    ],
    "primaryTopic": "Binary Search",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original binary search interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0026",
    "title": "Strings Challenge 26",
    "slug": "strings-challenge-26",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 26,
    "difficulty": "Medium",
    "patterns": [
      "Strings"
    ],
    "primaryTopic": "Strings",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original strings interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0027",
    "title": "Sliding Window Challenge 27",
    "slug": "sliding-window-challenge-27",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 27,
    "difficulty": "Medium",
    "patterns": [
      "Sliding Window"
    ],
    "primaryTopic": "Sliding Window",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original sliding window interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0028",
    "title": "Stack Challenge 28",
    "slug": "stack-challenge-28",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 28,
    "difficulty": "Medium",
    "patterns": [
      "Stack"
    ],
    "primaryTopic": "Stack",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original stack interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0029",
    "title": "Queue Challenge 29",
    "slug": "queue-challenge-29",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 29,
    "difficulty": "Medium",
    "patterns": [
      "Queue"
    ],
    "primaryTopic": "Queue",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original queue interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0030",
    "title": "Binary Search Challenge 30",
    "slug": "binary-search-challenge-30",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 30,
    "difficulty": "Medium",
    "patterns": [
      "Binary Search"
    ],
    "primaryTopic": "Binary Search",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original binary search interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0031",
    "title": "Strings Challenge 31",
    "slug": "strings-challenge-31",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 31,
    "difficulty": "Medium",
    "patterns": [
      "Strings"
    ],
    "primaryTopic": "Strings",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original strings interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0032",
    "title": "Sliding Window Challenge 32",
    "slug": "sliding-window-challenge-32",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 32,
    "difficulty": "Medium",
    "patterns": [
      "Sliding Window"
    ],
    "primaryTopic": "Sliding Window",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original sliding window interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0033",
    "title": "Stack Challenge 33",
    "slug": "stack-challenge-33",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 33,
    "difficulty": "Medium",
    "patterns": [
      "Stack"
    ],
    "primaryTopic": "Stack",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original stack interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0034",
    "title": "Queue Challenge 34",
    "slug": "queue-challenge-34",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 34,
    "difficulty": "Medium",
    "patterns": [
      "Queue"
    ],
    "primaryTopic": "Queue",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original queue interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0035",
    "title": "Binary Search Challenge 35",
    "slug": "binary-search-challenge-35",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 35,
    "difficulty": "Medium",
    "patterns": [
      "Binary Search"
    ],
    "primaryTopic": "Binary Search",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original binary search interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0036",
    "title": "Strings Challenge 36",
    "slug": "strings-challenge-36",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 36,
    "difficulty": "Hard",
    "patterns": [
      "Strings"
    ],
    "primaryTopic": "Strings",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original strings interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0037",
    "title": "Sliding Window Challenge 37",
    "slug": "sliding-window-challenge-37",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 37,
    "difficulty": "Hard",
    "patterns": [
      "Sliding Window"
    ],
    "primaryTopic": "Sliding Window",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original sliding window interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0038",
    "title": "Stack Challenge 38",
    "slug": "stack-challenge-38",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 38,
    "difficulty": "Hard",
    "patterns": [
      "Stack"
    ],
    "primaryTopic": "Stack",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original stack interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0039",
    "title": "Queue Challenge 39",
    "slug": "queue-challenge-39",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 39,
    "difficulty": "Hard",
    "patterns": [
      "Queue"
    ],
    "primaryTopic": "Queue",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original queue interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0040",
    "title": "Binary Search Challenge 40",
    "slug": "binary-search-challenge-40",
    "batchNumber": 2,
    "batchLabel": "Batch 2 - Problems 21 to 40",
    "globalOrdinal": 40,
    "difficulty": "Hard",
    "patterns": [
      "Binary Search"
    ],
    "primaryTopic": "Binary Search",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Create an algorithm to solve an original binary search interview problem. Given the specified input, compute the required result efficiently while handling edge cases and duplicate values where applicable.",
    "inputFormat": "See first line for n followed by required values.",
    "outputFormat": "Print the computed result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "6 1 2 3 4 5 6",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing for the given input.",
    "expectedApproach": "Use the optimal data structure and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_2_Problems_21_40.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_2_Problems_21_40.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0041",
    "title": "Trees Scenario 41",
    "slug": "trees-scenario-41",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 41,
    "difficulty": "Medium",
    "patterns": [
      "Trees"
    ],
    "primaryTopic": "Trees",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a trees-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0042",
    "title": "Graphs Scenario 42",
    "slug": "graphs-scenario-42",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 42,
    "difficulty": "Medium",
    "patterns": [
      "Graphs"
    ],
    "primaryTopic": "Graphs",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a graphs-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0043",
    "title": "Dynamic Programming Scenario 43",
    "slug": "dynamic-programming-scenario-43",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 43,
    "difficulty": "Medium",
    "patterns": [
      "Dynamic Programming"
    ],
    "primaryTopic": "Dynamic Programming",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a dynamic programming-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0044",
    "title": "Greedy Scenario 44",
    "slug": "greedy-scenario-44",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 44,
    "difficulty": "Medium",
    "patterns": [
      "Greedy"
    ],
    "primaryTopic": "Greedy",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a greedy-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0045",
    "title": "Heap Scenario 45",
    "slug": "heap-scenario-45",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 45,
    "difficulty": "Medium",
    "patterns": [
      "Heap"
    ],
    "primaryTopic": "Heap",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a heap-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0046",
    "title": "Trees Scenario 46",
    "slug": "trees-scenario-46",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 46,
    "difficulty": "Medium",
    "patterns": [
      "Trees"
    ],
    "primaryTopic": "Trees",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a trees-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0047",
    "title": "Graphs Scenario 47",
    "slug": "graphs-scenario-47",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 47,
    "difficulty": "Medium",
    "patterns": [
      "Graphs"
    ],
    "primaryTopic": "Graphs",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a graphs-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0048",
    "title": "Dynamic Programming Scenario 48",
    "slug": "dynamic-programming-scenario-48",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 48,
    "difficulty": "Medium",
    "patterns": [
      "Dynamic Programming"
    ],
    "primaryTopic": "Dynamic Programming",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a dynamic programming-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0049",
    "title": "Greedy Scenario 49",
    "slug": "greedy-scenario-49",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 49,
    "difficulty": "Medium",
    "patterns": [
      "Greedy"
    ],
    "primaryTopic": "Greedy",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a greedy-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0050",
    "title": "Heap Scenario 50",
    "slug": "heap-scenario-50",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 50,
    "difficulty": "Medium",
    "patterns": [
      "Heap"
    ],
    "primaryTopic": "Heap",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a heap-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0051",
    "title": "Trees Scenario 51",
    "slug": "trees-scenario-51",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 51,
    "difficulty": "Hard",
    "patterns": [
      "Trees"
    ],
    "primaryTopic": "Trees",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a trees-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0052",
    "title": "Graphs Scenario 52",
    "slug": "graphs-scenario-52",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 52,
    "difficulty": "Hard",
    "patterns": [
      "Graphs"
    ],
    "primaryTopic": "Graphs",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a graphs-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0053",
    "title": "Dynamic Programming Scenario 53",
    "slug": "dynamic-programming-scenario-53",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 53,
    "difficulty": "Hard",
    "patterns": [
      "Dynamic Programming"
    ],
    "primaryTopic": "Dynamic Programming",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a dynamic programming-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0054",
    "title": "Greedy Scenario 54",
    "slug": "greedy-scenario-54",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 54,
    "difficulty": "Hard",
    "patterns": [
      "Greedy"
    ],
    "primaryTopic": "Greedy",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a greedy-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0055",
    "title": "Heap Scenario 55",
    "slug": "heap-scenario-55",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 55,
    "difficulty": "Hard",
    "patterns": [
      "Heap"
    ],
    "primaryTopic": "Heap",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a heap-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0056",
    "title": "Trees Scenario 56",
    "slug": "trees-scenario-56",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 56,
    "difficulty": "Hard",
    "patterns": [
      "Trees"
    ],
    "primaryTopic": "Trees",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a trees-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0057",
    "title": "Graphs Scenario 57",
    "slug": "graphs-scenario-57",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 57,
    "difficulty": "Hard",
    "patterns": [
      "Graphs"
    ],
    "primaryTopic": "Graphs",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a graphs-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0058",
    "title": "Dynamic Programming Scenario 58",
    "slug": "dynamic-programming-scenario-58",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 58,
    "difficulty": "Hard",
    "patterns": [
      "Dynamic Programming"
    ],
    "primaryTopic": "Dynamic Programming",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a dynamic programming-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0059",
    "title": "Greedy Scenario 59",
    "slug": "greedy-scenario-59",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 59,
    "difficulty": "Hard",
    "patterns": [
      "Greedy"
    ],
    "primaryTopic": "Greedy",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a greedy-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0060",
    "title": "Heap Scenario 60",
    "slug": "heap-scenario-60",
    "batchNumber": 3,
    "batchLabel": "Batch 3 - Problems 41 to 60",
    "globalOrdinal": 60,
    "difficulty": "Hard",
    "patterns": [
      "Heap"
    ],
    "primaryTopic": "Heap",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Common interview pattern",
    "statement": "You are given data representing a heap-based system. Design an efficient algorithm to compute the required answer while satisfying all constraints. Your solution should correctly handle duplicate values, minimum-size inputs, and maximum-size inputs.",
    "inputFormat": "First line contains an integer n followed by problem-specific values.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 2 3 4 5",
    "sampleOutput": "Example",
    "explanation": "Process the input according to the rules and produce the expected output.",
    "expectedApproach": "Use an optimal algorithm for this topic and avoid brute-force solutions.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_3_Problems_41_60.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_3_Problems_41_60.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0061",
    "title": "Binary Search Challenge 61",
    "slug": "binary-search-challenge-61",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 61,
    "difficulty": "Medium",
    "patterns": [
      "Binary Search"
    ],
    "primaryTopic": "Binary Search",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a binary search problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0062",
    "title": "Trie Challenge 62",
    "slug": "trie-challenge-62",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 62,
    "difficulty": "Medium",
    "patterns": [
      "Trie"
    ],
    "primaryTopic": "Trie",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a trie problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0063",
    "title": "Backtracking Challenge 63",
    "slug": "backtracking-challenge-63",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 63,
    "difficulty": "Medium",
    "patterns": [
      "Backtracking"
    ],
    "primaryTopic": "Backtracking",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a backtracking problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0064",
    "title": "Bit Manipulation Challenge 64",
    "slug": "bit-manipulation-challenge-64",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 64,
    "difficulty": "Medium",
    "patterns": [
      "Bit Manipulation"
    ],
    "primaryTopic": "Bit Manipulation",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a bit manipulation problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0065",
    "title": "Linked List Challenge 65",
    "slug": "linked-list-challenge-65",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 65,
    "difficulty": "Medium",
    "patterns": [
      "Linked List"
    ],
    "primaryTopic": "Linked List",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a linked list problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0066",
    "title": "Sliding Window Challenge 66",
    "slug": "sliding-window-challenge-66",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 66,
    "difficulty": "Medium",
    "patterns": [
      "Sliding Window"
    ],
    "primaryTopic": "Sliding Window",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a sliding window problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0067",
    "title": "Hashing Challenge 67",
    "slug": "hashing-challenge-67",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 67,
    "difficulty": "Medium",
    "patterns": [
      "Hashing"
    ],
    "primaryTopic": "Hashing",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a hashing problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0068",
    "title": "Graphs Challenge 68",
    "slug": "graphs-challenge-68",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 68,
    "difficulty": "Medium",
    "patterns": [
      "Graphs"
    ],
    "primaryTopic": "Graphs",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a graphs problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0069",
    "title": "Trees Challenge 69",
    "slug": "trees-challenge-69",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 69,
    "difficulty": "Medium",
    "patterns": [
      "Trees"
    ],
    "primaryTopic": "Trees",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a trees problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0070",
    "title": "Dynamic Programming Challenge 70",
    "slug": "dynamic-programming-challenge-70",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 70,
    "difficulty": "Medium",
    "patterns": [
      "Dynamic Programming"
    ],
    "primaryTopic": "Dynamic Programming",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a dynamic programming problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0071",
    "title": "Binary Search Challenge 71",
    "slug": "binary-search-challenge-71",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 71,
    "difficulty": "Hard",
    "patterns": [
      "Binary Search"
    ],
    "primaryTopic": "Binary Search",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a binary search problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0072",
    "title": "Trie Challenge 72",
    "slug": "trie-challenge-72",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 72,
    "difficulty": "Hard",
    "patterns": [
      "Trie"
    ],
    "primaryTopic": "Trie",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a trie problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0073",
    "title": "Backtracking Challenge 73",
    "slug": "backtracking-challenge-73",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 73,
    "difficulty": "Hard",
    "patterns": [
      "Backtracking"
    ],
    "primaryTopic": "Backtracking",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a backtracking problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0074",
    "title": "Bit Manipulation Challenge 74",
    "slug": "bit-manipulation-challenge-74",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 74,
    "difficulty": "Hard",
    "patterns": [
      "Bit Manipulation"
    ],
    "primaryTopic": "Bit Manipulation",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a bit manipulation problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0075",
    "title": "Linked List Challenge 75",
    "slug": "linked-list-challenge-75",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 75,
    "difficulty": "Hard",
    "patterns": [
      "Linked List"
    ],
    "primaryTopic": "Linked List",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a linked list problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0076",
    "title": "Sliding Window Challenge 76",
    "slug": "sliding-window-challenge-76",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 76,
    "difficulty": "Hard",
    "patterns": [
      "Sliding Window"
    ],
    "primaryTopic": "Sliding Window",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a sliding window problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0077",
    "title": "Hashing Challenge 77",
    "slug": "hashing-challenge-77",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 77,
    "difficulty": "Hard",
    "patterns": [
      "Hashing"
    ],
    "primaryTopic": "Hashing",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a hashing problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0078",
    "title": "Graphs Challenge 78",
    "slug": "graphs-challenge-78",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 78,
    "difficulty": "Hard",
    "patterns": [
      "Graphs"
    ],
    "primaryTopic": "Graphs",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a graphs problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0079",
    "title": "Trees Challenge 79",
    "slug": "trees-challenge-79",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 79,
    "difficulty": "Hard",
    "patterns": [
      "Trees"
    ],
    "primaryTopic": "Trees",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a trees problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0080",
    "title": "Dynamic Programming Challenge 80",
    "slug": "dynamic-programming-challenge-80",
    "batchNumber": 4,
    "batchLabel": "Batch 4 - Problems 61 to 80",
    "globalOrdinal": 80,
    "difficulty": "Hard",
    "patterns": [
      "Dynamic Programming"
    ],
    "primaryTopic": "Dynamic Programming",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Adobe"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given input describing a dynamic programming problem, compute the requested result efficiently. Your algorithm must work for both small and large datasets, correctly handle edge cases, and satisfy all stated constraints.",
    "inputFormat": "The first line contains an integer n. Remaining input contains values specific to the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Values fit within signed 32-bit integers unless otherwise specified.",
    "sampleInput": "5 10 20 30 40 50",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates the expected processing for the given input.",
    "expectedApproach": "Choose the optimal algorithm and appropriate data structures instead of brute force.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_4_Problems_61_80.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_4_Problems_61_80.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0081",
    "title": "Arrays Mission 81",
    "slug": "arrays-mission-81",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 81,
    "difficulty": "Medium",
    "patterns": [
      "Arrays",
      "Advanced Arrays"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving arrays. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0082",
    "title": "Strings Mission 82",
    "slug": "strings-mission-82",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 82,
    "difficulty": "Medium",
    "patterns": [
      "Strings",
      "Advanced Strings"
    ],
    "primaryTopic": "Strings",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving strings. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0083",
    "title": "Graphs Mission 83",
    "slug": "graphs-mission-83",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 83,
    "difficulty": "Medium",
    "patterns": [
      "Graphs",
      "Advanced Graphs"
    ],
    "primaryTopic": "Graphs",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving graphs. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0084",
    "title": "Trees Mission 84",
    "slug": "trees-mission-84",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 84,
    "difficulty": "Medium",
    "patterns": [
      "Trees",
      "Advanced Trees"
    ],
    "primaryTopic": "Trees",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving trees. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0085",
    "title": "Dynamic Programming Mission 85",
    "slug": "dynamic-programming-mission-85",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 85,
    "difficulty": "Medium",
    "patterns": [
      "Dynamic Programming",
      "Advanced Dynamic Programming"
    ],
    "primaryTopic": "Dynamic Programming",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving dynamic programming. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0086",
    "title": "Greedy Mission 86",
    "slug": "greedy-mission-86",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 86,
    "difficulty": "Medium",
    "patterns": [
      "Greedy",
      "Advanced Greedy"
    ],
    "primaryTopic": "Greedy",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving greedy. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0087",
    "title": "Heap Mission 87",
    "slug": "heap-mission-87",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 87,
    "difficulty": "Medium",
    "patterns": [
      "Heap",
      "Advanced Heap"
    ],
    "primaryTopic": "Heap",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving heap. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0088",
    "title": "Binary Search Mission 88",
    "slug": "binary-search-mission-88",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 88,
    "difficulty": "Medium",
    "patterns": [
      "Binary Search",
      "Advanced Binary Search"
    ],
    "primaryTopic": "Binary Search",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving binary search. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0089",
    "title": "Trie Mission 89",
    "slug": "trie-mission-89",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 89,
    "difficulty": "Medium",
    "patterns": [
      "Trie",
      "Advanced Trie"
    ],
    "primaryTopic": "Trie",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving trie. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0090",
    "title": "Backtracking Mission 90",
    "slug": "backtracking-mission-90",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 90,
    "difficulty": "Medium",
    "patterns": [
      "Backtracking",
      "Advanced Backtracking"
    ],
    "primaryTopic": "Backtracking",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving backtracking. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0091",
    "title": "Arrays Mission 91",
    "slug": "arrays-mission-91",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 91,
    "difficulty": "Hard",
    "patterns": [
      "Arrays",
      "Advanced Arrays"
    ],
    "primaryTopic": "Arrays",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving arrays. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0092",
    "title": "Strings Mission 92",
    "slug": "strings-mission-92",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 92,
    "difficulty": "Hard",
    "patterns": [
      "Strings",
      "Advanced Strings"
    ],
    "primaryTopic": "Strings",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving strings. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0093",
    "title": "Graphs Mission 93",
    "slug": "graphs-mission-93",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 93,
    "difficulty": "Hard",
    "patterns": [
      "Graphs",
      "Advanced Graphs"
    ],
    "primaryTopic": "Graphs",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving graphs. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0094",
    "title": "Trees Mission 94",
    "slug": "trees-mission-94",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 94,
    "difficulty": "Hard",
    "patterns": [
      "Trees",
      "Advanced Trees"
    ],
    "primaryTopic": "Trees",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving trees. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0095",
    "title": "Dynamic Programming Mission 95",
    "slug": "dynamic-programming-mission-95",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 95,
    "difficulty": "Hard",
    "patterns": [
      "Dynamic Programming",
      "Advanced Dynamic Programming"
    ],
    "primaryTopic": "Dynamic Programming",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving dynamic programming. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0096",
    "title": "Greedy Mission 96",
    "slug": "greedy-mission-96",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 96,
    "difficulty": "Hard",
    "patterns": [
      "Greedy",
      "Advanced Greedy"
    ],
    "primaryTopic": "Greedy",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving greedy. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0097",
    "title": "Heap Mission 97",
    "slug": "heap-mission-97",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 97,
    "difficulty": "Hard",
    "patterns": [
      "Heap",
      "Advanced Heap"
    ],
    "primaryTopic": "Heap",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving heap. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0098",
    "title": "Binary Search Mission 98",
    "slug": "binary-search-mission-98",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 98,
    "difficulty": "Hard",
    "patterns": [
      "Binary Search",
      "Advanced Binary Search"
    ],
    "primaryTopic": "Binary Search",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving binary search. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0099",
    "title": "Trie Mission 99",
    "slug": "trie-mission-99",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 99,
    "difficulty": "Hard",
    "patterns": [
      "Trie",
      "Advanced Trie"
    ],
    "primaryTopic": "Trie",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving trie. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0100",
    "title": "Backtracking Mission 100",
    "slug": "backtracking-mission-100",
    "batchNumber": 5,
    "batchLabel": "Batch 5 - Problems 81 to 100",
    "globalOrdinal": 100,
    "difficulty": "Hard",
    "patterns": [
      "Backtracking",
      "Advanced Backtracking"
    ],
    "primaryTopic": "Backtracking",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "Very High",
    "platformSimilarTo": "Common coding interview pattern",
    "statement": "You are given a dataset involving backtracking. Build an efficient algorithm that produces the required output while meeting all constraints. Your solution should scale to the maximum input size, correctly process duplicate values when applicable, and return the expected result for every valid test case.",
    "inputFormat": "Line 1: integer n. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000 Time-efficient solution expected.",
    "sampleInput": "6 3 5 8 2 9 1",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected processing sequence and output.",
    "expectedApproach": "Identify the optimal algorithmic pattern for this category and avoid unnecessary nested iterations.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_5_Problems_81_100.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_5_Problems_81_100.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0101",
    "title": "Union Find Explorer 101",
    "slug": "union-find-explorer-101",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 101,
    "difficulty": "Medium",
    "patterns": [
      "Union Find"
    ],
    "primaryTopic": "Union Find",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a union find scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0102",
    "title": "Prefix Sum Explorer 102",
    "slug": "prefix-sum-explorer-102",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 102,
    "difficulty": "Hard",
    "patterns": [
      "Prefix Sum"
    ],
    "primaryTopic": "Prefix Sum",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a prefix sum scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0103",
    "title": "Monotonic Stack Explorer 103",
    "slug": "monotonic-stack-explorer-103",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 103,
    "difficulty": "Medium",
    "patterns": [
      "Monotonic Stack"
    ],
    "primaryTopic": "Monotonic Stack",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a monotonic stack scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0104",
    "title": "Deque Explorer 104",
    "slug": "deque-explorer-104",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 104,
    "difficulty": "Medium",
    "patterns": [
      "Deque"
    ],
    "primaryTopic": "Deque",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a deque scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0105",
    "title": "Topological Sort Explorer 105",
    "slug": "topological-sort-explorer-105",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 105,
    "difficulty": "Hard",
    "patterns": [
      "Topological Sort"
    ],
    "primaryTopic": "Topological Sort",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a topological sort scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0106",
    "title": "DFS Explorer 106",
    "slug": "dfs-explorer-106",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 106,
    "difficulty": "Medium",
    "patterns": [
      "DFS"
    ],
    "primaryTopic": "DFS",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a dfs scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0107",
    "title": "BFS Explorer 107",
    "slug": "bfs-explorer-107",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 107,
    "difficulty": "Medium",
    "patterns": [
      "BFS"
    ],
    "primaryTopic": "BFS",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a bfs scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0108",
    "title": "Intervals Explorer 108",
    "slug": "intervals-explorer-108",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 108,
    "difficulty": "Hard",
    "patterns": [
      "Intervals"
    ],
    "primaryTopic": "Intervals",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a intervals scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0109",
    "title": "Recursion Explorer 109",
    "slug": "recursion-explorer-109",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 109,
    "difficulty": "Medium",
    "patterns": [
      "Recursion"
    ],
    "primaryTopic": "Recursion",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a recursion scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0110",
    "title": "Matrix Explorer 110",
    "slug": "matrix-explorer-110",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 110,
    "difficulty": "Medium",
    "patterns": [
      "Matrix"
    ],
    "primaryTopic": "Matrix",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a matrix scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0111",
    "title": "Union Find Explorer 111",
    "slug": "union-find-explorer-111",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 111,
    "difficulty": "Hard",
    "patterns": [
      "Union Find"
    ],
    "primaryTopic": "Union Find",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a union find scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0112",
    "title": "Prefix Sum Explorer 112",
    "slug": "prefix-sum-explorer-112",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 112,
    "difficulty": "Medium",
    "patterns": [
      "Prefix Sum"
    ],
    "primaryTopic": "Prefix Sum",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a prefix sum scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0113",
    "title": "Monotonic Stack Explorer 113",
    "slug": "monotonic-stack-explorer-113",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 113,
    "difficulty": "Medium",
    "patterns": [
      "Monotonic Stack"
    ],
    "primaryTopic": "Monotonic Stack",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a monotonic stack scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0114",
    "title": "Deque Explorer 114",
    "slug": "deque-explorer-114",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 114,
    "difficulty": "Hard",
    "patterns": [
      "Deque"
    ],
    "primaryTopic": "Deque",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a deque scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0115",
    "title": "Topological Sort Explorer 115",
    "slug": "topological-sort-explorer-115",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 115,
    "difficulty": "Medium",
    "patterns": [
      "Topological Sort"
    ],
    "primaryTopic": "Topological Sort",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a topological sort scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0116",
    "title": "DFS Explorer 116",
    "slug": "dfs-explorer-116",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 116,
    "difficulty": "Medium",
    "patterns": [
      "DFS"
    ],
    "primaryTopic": "DFS",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a dfs scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0117",
    "title": "BFS Explorer 117",
    "slug": "bfs-explorer-117",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 117,
    "difficulty": "Hard",
    "patterns": [
      "BFS"
    ],
    "primaryTopic": "BFS",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a bfs scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0118",
    "title": "Intervals Explorer 118",
    "slug": "intervals-explorer-118",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 118,
    "difficulty": "Medium",
    "patterns": [
      "Intervals"
    ],
    "primaryTopic": "Intervals",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a intervals scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0119",
    "title": "Recursion Explorer 119",
    "slug": "recursion-explorer-119",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 119,
    "difficulty": "Medium",
    "patterns": [
      "Recursion"
    ],
    "primaryTopic": "Recursion",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a recursion scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0120",
    "title": "Matrix Explorer 120",
    "slug": "matrix-explorer-120",
    "batchNumber": 6,
    "batchLabel": "Batch 6 - Problems 101 to 120",
    "globalOrdinal": 120,
    "difficulty": "Hard",
    "patterns": [
      "Matrix"
    ],
    "primaryTopic": "Matrix",
    "companies": [
      "Amazon",
      "Google",
      "Microsoft",
      "Meta",
      "Atlassian"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": "Interview coding pattern",
    "statement": "You are given data representing a matrix scenario. Design an efficient algorithm that computes the required result while satisfying all constraints. Your solution should handle edge cases, duplicate values where applicable, and the largest valid input sizes.",
    "inputFormat": "The first line contains the primary size parameter. Remaining lines contain the values required for the problem.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 3 5 7 9",
    "sampleOutput": "Example",
    "explanation": "The example illustrates the expected behavior for one valid test case.",
    "expectedApproach": "Use the optimal algorithm and appropriate data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_6_Problems_101_120.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_6_Problems_101_120.txt",
    "qualityFlags": [
      "placeholder-sample-output"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0121",
    "title": "Segment Tree Quest 121",
    "slug": "segment-tree-quest-121",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 121,
    "difficulty": "Hard",
    "patterns": [
      "Segment Tree"
    ],
    "primaryTopic": "Segment Tree",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original segment tree scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0122",
    "title": "Fenwick Tree Quest 122",
    "slug": "fenwick-tree-quest-122",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 122,
    "difficulty": "Hard",
    "patterns": [
      "Fenwick Tree"
    ],
    "primaryTopic": "Fenwick Tree",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original fenwick tree scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0123",
    "title": "Shortest Path Quest 123",
    "slug": "shortest-path-quest-123",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 123,
    "difficulty": "Hard",
    "patterns": [
      "Shortest Path"
    ],
    "primaryTopic": "Shortest Path",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original shortest path scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0124",
    "title": "Minimum Spanning Tree Quest 124",
    "slug": "minimum-spanning-tree-quest-124",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 124,
    "difficulty": "Hard",
    "patterns": [
      "Minimum Spanning Tree"
    ],
    "primaryTopic": "Minimum Spanning Tree",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original minimum spanning tree scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0125",
    "title": "Binary Lifting Quest 125",
    "slug": "binary-lifting-quest-125",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 125,
    "difficulty": "Hard",
    "patterns": [
      "Binary Lifting"
    ],
    "primaryTopic": "Binary Lifting",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original binary lifting scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0126",
    "title": "Knapsack Quest 126",
    "slug": "knapsack-quest-126",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 126,
    "difficulty": "Hard",
    "patterns": [
      "Knapsack"
    ],
    "primaryTopic": "Knapsack",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original knapsack scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0127",
    "title": "Bitmask DP Quest 127",
    "slug": "bitmask-dp-quest-127",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 127,
    "difficulty": "Hard",
    "patterns": [
      "Bitmask DP"
    ],
    "primaryTopic": "Bitmask DP",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original bitmask dp scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0128",
    "title": "Geometry Quest 128",
    "slug": "geometry-quest-128",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 128,
    "difficulty": "Hard",
    "patterns": [
      "Geometry"
    ],
    "primaryTopic": "Geometry",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original geometry scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0129",
    "title": "Simulation Quest 129",
    "slug": "simulation-quest-129",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 129,
    "difficulty": "Hard",
    "patterns": [
      "Simulation"
    ],
    "primaryTopic": "Simulation",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original simulation scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0130",
    "title": "String Matching Quest 130",
    "slug": "string-matching-quest-130",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 130,
    "difficulty": "Hard",
    "patterns": [
      "String Matching"
    ],
    "primaryTopic": "String Matching",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original string matching scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0131",
    "title": "Segment Tree Quest 131",
    "slug": "segment-tree-quest-131",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 131,
    "difficulty": "Hard",
    "patterns": [
      "Segment Tree"
    ],
    "primaryTopic": "Segment Tree",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original segment tree scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0132",
    "title": "Fenwick Tree Quest 132",
    "slug": "fenwick-tree-quest-132",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 132,
    "difficulty": "Hard",
    "patterns": [
      "Fenwick Tree"
    ],
    "primaryTopic": "Fenwick Tree",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original fenwick tree scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0133",
    "title": "Shortest Path Quest 133",
    "slug": "shortest-path-quest-133",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 133,
    "difficulty": "Hard",
    "patterns": [
      "Shortest Path"
    ],
    "primaryTopic": "Shortest Path",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original shortest path scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0134",
    "title": "Minimum Spanning Tree Quest 134",
    "slug": "minimum-spanning-tree-quest-134",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 134,
    "difficulty": "Hard",
    "patterns": [
      "Minimum Spanning Tree"
    ],
    "primaryTopic": "Minimum Spanning Tree",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original minimum spanning tree scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0135",
    "title": "Binary Lifting Quest 135",
    "slug": "binary-lifting-quest-135",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 135,
    "difficulty": "Hard",
    "patterns": [
      "Binary Lifting"
    ],
    "primaryTopic": "Binary Lifting",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original binary lifting scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0136",
    "title": "Knapsack Quest 136",
    "slug": "knapsack-quest-136",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 136,
    "difficulty": "Hard",
    "patterns": [
      "Knapsack"
    ],
    "primaryTopic": "Knapsack",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original knapsack scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0137",
    "title": "Bitmask DP Quest 137",
    "slug": "bitmask-dp-quest-137",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 137,
    "difficulty": "Hard",
    "patterns": [
      "Bitmask DP"
    ],
    "primaryTopic": "Bitmask DP",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original bitmask dp scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0138",
    "title": "Geometry Quest 138",
    "slug": "geometry-quest-138",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 138,
    "difficulty": "Hard",
    "patterns": [
      "Geometry"
    ],
    "primaryTopic": "Geometry",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original geometry scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0139",
    "title": "Simulation Quest 139",
    "slug": "simulation-quest-139",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 139,
    "difficulty": "Hard",
    "patterns": [
      "Simulation"
    ],
    "primaryTopic": "Simulation",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original simulation scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0140",
    "title": "String Matching Quest 140",
    "slug": "string-matching-quest-140",
    "batchNumber": 7,
    "batchLabel": "Batch 7 - Problems 121 to 140",
    "globalOrdinal": 140,
    "difficulty": "Hard",
    "patterns": [
      "String Matching"
    ],
    "primaryTopic": "String Matching",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Uber"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Given an original string matching scenario, design an efficient algorithm that satisfies the constraints and returns the required output for all valid inputs.",
    "inputFormat": "First line contains problem size. Remaining lines contain problem-specific values.",
    "outputFormat": "Print the required answer.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "4 2 4 6 8",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates the expected behavior.",
    "expectedApproach": "Use the optimal algorithm and data structures for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_7_Problems_121_140.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_7_Problems_121_140.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0141",
    "title": "Disjoint Set Challenge 141",
    "slug": "disjoint-set-challenge-141",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 141,
    "difficulty": "Hard",
    "patterns": [
      "Disjoint Set"
    ],
    "primaryTopic": "Disjoint Set",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving disjoint set. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0142",
    "title": "Matrix Challenge 142",
    "slug": "matrix-challenge-142",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 142,
    "difficulty": "Hard",
    "patterns": [
      "Matrix"
    ],
    "primaryTopic": "Matrix",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving matrix. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0143",
    "title": "Combinatorics Challenge 143",
    "slug": "combinatorics-challenge-143",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 143,
    "difficulty": "Hard",
    "patterns": [
      "Combinatorics"
    ],
    "primaryTopic": "Combinatorics",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving combinatorics. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0144",
    "title": "Rolling Hash Challenge 144",
    "slug": "rolling-hash-challenge-144",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 144,
    "difficulty": "Hard",
    "patterns": [
      "Rolling Hash"
    ],
    "primaryTopic": "Rolling Hash",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving rolling hash. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0145",
    "title": "KMP Challenge 145",
    "slug": "kmp-challenge-145",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 145,
    "difficulty": "Hard",
    "patterns": [
      "KMP"
    ],
    "primaryTopic": "KMP",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving kmp. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0146",
    "title": "Suffix Array Challenge 146",
    "slug": "suffix-array-challenge-146",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 146,
    "difficulty": "Hard",
    "patterns": [
      "Suffix Array"
    ],
    "primaryTopic": "Suffix Array",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving suffix array. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0147",
    "title": "Binary Indexed Tree Challenge 147",
    "slug": "binary-indexed-tree-challenge-147",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 147,
    "difficulty": "Hard",
    "patterns": [
      "Binary Indexed Tree"
    ],
    "primaryTopic": "Binary Indexed Tree",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving binary indexed tree. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0148",
    "title": "Network Flow Challenge 148",
    "slug": "network-flow-challenge-148",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 148,
    "difficulty": "Hard",
    "patterns": [
      "Network Flow"
    ],
    "primaryTopic": "Network Flow",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving network flow. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0149",
    "title": "Scheduling Challenge 149",
    "slug": "scheduling-challenge-149",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 149,
    "difficulty": "Hard",
    "patterns": [
      "Scheduling"
    ],
    "primaryTopic": "Scheduling",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving scheduling. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0150",
    "title": "Game Theory Challenge 150",
    "slug": "game-theory-challenge-150",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 150,
    "difficulty": "Hard",
    "patterns": [
      "Game Theory"
    ],
    "primaryTopic": "Game Theory",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving game theory. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0151",
    "title": "Disjoint Set Challenge 151",
    "slug": "disjoint-set-challenge-151",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 151,
    "difficulty": "Hard",
    "patterns": [
      "Disjoint Set"
    ],
    "primaryTopic": "Disjoint Set",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving disjoint set. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0152",
    "title": "Matrix Challenge 152",
    "slug": "matrix-challenge-152",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 152,
    "difficulty": "Hard",
    "patterns": [
      "Matrix"
    ],
    "primaryTopic": "Matrix",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving matrix. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0153",
    "title": "Combinatorics Challenge 153",
    "slug": "combinatorics-challenge-153",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 153,
    "difficulty": "Hard",
    "patterns": [
      "Combinatorics"
    ],
    "primaryTopic": "Combinatorics",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving combinatorics. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0154",
    "title": "Rolling Hash Challenge 154",
    "slug": "rolling-hash-challenge-154",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 154,
    "difficulty": "Hard",
    "patterns": [
      "Rolling Hash"
    ],
    "primaryTopic": "Rolling Hash",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving rolling hash. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0155",
    "title": "KMP Challenge 155",
    "slug": "kmp-challenge-155",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 155,
    "difficulty": "Hard",
    "patterns": [
      "KMP"
    ],
    "primaryTopic": "KMP",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving kmp. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0156",
    "title": "Suffix Array Challenge 156",
    "slug": "suffix-array-challenge-156",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 156,
    "difficulty": "Hard",
    "patterns": [
      "Suffix Array"
    ],
    "primaryTopic": "Suffix Array",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving suffix array. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0157",
    "title": "Binary Indexed Tree Challenge 157",
    "slug": "binary-indexed-tree-challenge-157",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 157,
    "difficulty": "Hard",
    "patterns": [
      "Binary Indexed Tree"
    ],
    "primaryTopic": "Binary Indexed Tree",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving binary indexed tree. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0158",
    "title": "Network Flow Challenge 158",
    "slug": "network-flow-challenge-158",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 158,
    "difficulty": "Hard",
    "patterns": [
      "Network Flow"
    ],
    "primaryTopic": "Network Flow",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving network flow. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0159",
    "title": "Scheduling Challenge 159",
    "slug": "scheduling-challenge-159",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 159,
    "difficulty": "Hard",
    "patterns": [
      "Scheduling"
    ],
    "primaryTopic": "Scheduling",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving scheduling. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0160",
    "title": "Game Theory Challenge 160",
    "slug": "game-theory-challenge-160",
    "batchNumber": 8,
    "batchLabel": "Batch 8 - Problems 141 to 160",
    "globalOrdinal": 160,
    "difficulty": "Hard",
    "patterns": [
      "Game Theory"
    ],
    "primaryTopic": "Game Theory",
    "companies": [
      "Google",
      "Amazon",
      "Microsoft",
      "Meta",
      "Apple"
    ],
    "interviewFrequency": "High",
    "platformSimilarTo": null,
    "statement": "Design an efficient solution for an original interview-style problem involving game theory. The algorithm should satisfy all constraints and correctly handle corner cases.",
    "inputFormat": "The first line contains the size parameter. Subsequent lines contain problem-specific input.",
    "outputFormat": "Print the required answer in the specified format.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 4 8 15 16 23",
    "sampleOutput": "Example",
    "explanation": "The sample illustrates one valid execution of the algorithm.",
    "expectedApproach": "Use the optimal data structure and algorithm for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_8_Problems_141_160.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_8_Problems_141_160.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0161",
    "title": "Digit DP Expedition 161",
    "slug": "digit-dp-expedition-161",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 161,
    "difficulty": "Hard",
    "patterns": [
      "Digit DP"
    ],
    "primaryTopic": "Digit DP",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on digit dp. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0162",
    "title": "Meet in the Middle Expedition 162",
    "slug": "meet-in-the-middle-expedition-162",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 162,
    "difficulty": "Hard",
    "patterns": [
      "Meet in the Middle"
    ],
    "primaryTopic": "Meet in the Middle",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on meet in the middle. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0163",
    "title": "Convex Hull Expedition 163",
    "slug": "convex-hull-expedition-163",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 163,
    "difficulty": "Hard",
    "patterns": [
      "Convex Hull"
    ],
    "primaryTopic": "Convex Hull",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on convex hull. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0164",
    "title": "Line Sweep Expedition 164",
    "slug": "line-sweep-expedition-164",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 164,
    "difficulty": "Hard",
    "patterns": [
      "Line Sweep"
    ],
    "primaryTopic": "Line Sweep",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on line sweep. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0165",
    "title": "Mo's Algorithm Expedition 165",
    "slug": "mo-s-algorithm-expedition-165",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 165,
    "difficulty": "Hard",
    "patterns": [
      "Mo's Algorithm"
    ],
    "primaryTopic": "Mo's Algorithm",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on mo's algorithm. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0166",
    "title": "Sparse Table Expedition 166",
    "slug": "sparse-table-expedition-166",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 166,
    "difficulty": "Hard",
    "patterns": [
      "Sparse Table"
    ],
    "primaryTopic": "Sparse Table",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on sparse table. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0167",
    "title": "Heavy Light Decomposition Expedition 167",
    "slug": "heavy-light-decomposition-expedition-167",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 167,
    "difficulty": "Hard",
    "patterns": [
      "Heavy Light Decomposition"
    ],
    "primaryTopic": "Heavy Light Decomposition",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on heavy light decomposition. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0168",
    "title": "Euler Tour Expedition 168",
    "slug": "euler-tour-expedition-168",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 168,
    "difficulty": "Hard",
    "patterns": [
      "Euler Tour"
    ],
    "primaryTopic": "Euler Tour",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on euler tour. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0169",
    "title": "Centroid Decomposition Expedition 169",
    "slug": "centroid-decomposition-expedition-169",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 169,
    "difficulty": "Hard",
    "patterns": [
      "Centroid Decomposition"
    ],
    "primaryTopic": "Centroid Decomposition",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on centroid decomposition. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0170",
    "title": "Aho-Corasick Expedition 170",
    "slug": "aho-corasick-expedition-170",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 170,
    "difficulty": "Hard",
    "patterns": [
      "Aho-Corasick"
    ],
    "primaryTopic": "Aho-Corasick",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on aho-corasick. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0171",
    "title": "Digit DP Expedition 171",
    "slug": "digit-dp-expedition-171",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 171,
    "difficulty": "Hard",
    "patterns": [
      "Digit DP"
    ],
    "primaryTopic": "Digit DP",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on digit dp. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0172",
    "title": "Meet in the Middle Expedition 172",
    "slug": "meet-in-the-middle-expedition-172",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 172,
    "difficulty": "Hard",
    "patterns": [
      "Meet in the Middle"
    ],
    "primaryTopic": "Meet in the Middle",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on meet in the middle. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0173",
    "title": "Convex Hull Expedition 173",
    "slug": "convex-hull-expedition-173",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 173,
    "difficulty": "Hard",
    "patterns": [
      "Convex Hull"
    ],
    "primaryTopic": "Convex Hull",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on convex hull. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0174",
    "title": "Line Sweep Expedition 174",
    "slug": "line-sweep-expedition-174",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 174,
    "difficulty": "Hard",
    "patterns": [
      "Line Sweep"
    ],
    "primaryTopic": "Line Sweep",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on line sweep. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0175",
    "title": "Mo's Algorithm Expedition 175",
    "slug": "mo-s-algorithm-expedition-175",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 175,
    "difficulty": "Hard",
    "patterns": [
      "Mo's Algorithm"
    ],
    "primaryTopic": "Mo's Algorithm",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on mo's algorithm. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0176",
    "title": "Sparse Table Expedition 176",
    "slug": "sparse-table-expedition-176",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 176,
    "difficulty": "Hard",
    "patterns": [
      "Sparse Table"
    ],
    "primaryTopic": "Sparse Table",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on sparse table. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0177",
    "title": "Heavy Light Decomposition Expedition 177",
    "slug": "heavy-light-decomposition-expedition-177",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 177,
    "difficulty": "Hard",
    "patterns": [
      "Heavy Light Decomposition"
    ],
    "primaryTopic": "Heavy Light Decomposition",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on heavy light decomposition. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0178",
    "title": "Euler Tour Expedition 178",
    "slug": "euler-tour-expedition-178",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 178,
    "difficulty": "Hard",
    "patterns": [
      "Euler Tour"
    ],
    "primaryTopic": "Euler Tour",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on euler tour. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0179",
    "title": "Centroid Decomposition Expedition 179",
    "slug": "centroid-decomposition-expedition-179",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 179,
    "difficulty": "Hard",
    "patterns": [
      "Centroid Decomposition"
    ],
    "primaryTopic": "Centroid Decomposition",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on centroid decomposition. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  },
  {
    "source": "docx-batch",
    "sourceId": "DSA0180",
    "title": "Aho-Corasick Expedition 180",
    "slug": "aho-corasick-expedition-180",
    "batchNumber": 9,
    "batchLabel": "Batch 9 - Problems 161 to 180",
    "globalOrdinal": 180,
    "difficulty": "Hard",
    "patterns": [
      "Aho-Corasick"
    ],
    "primaryTopic": "Aho-Corasick",
    "companies": [
      "Google",
      "Meta",
      "Amazon",
      "Microsoft"
    ],
    "interviewFrequency": "Medium",
    "platformSimilarTo": null,
    "statement": "Create an efficient algorithm for an original interview-style problem centered on aho-corasick. The solution must satisfy all constraints and handle edge cases correctly.",
    "inputFormat": "The first line contains the primary input size followed by problem-specific data.",
    "outputFormat": "Print the required result.",
    "constraints": "1 <= n <= 200000",
    "sampleInput": "5 1 4 9 16 25",
    "sampleOutput": "Example",
    "explanation": "The sample demonstrates one valid execution path.",
    "expectedApproach": "Apply the optimal algorithmic technique for this topic.",
    "timeComplexity": "O(n log n)",
    "spaceComplexity": "O(n)",
    "interactive": false,
    "sourceFile": "public/Batch_9_Problems_161_180.docx",
    "extractedTextFile": "tmp_docx_extract/Batch_9_Problems_161_180.txt",
    "qualityFlags": [
      "placeholder-sample-output",
      "templated-statement"
    ]
  }
];
